export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_ACCESS_PROFILE':
      return { ...state, accessProfile: action.accessProfile };
    case 'GET_ACCESS_PROFILE_TREE':
        return { ...state, accessProfileTree: action.accessProfileTree };
    case 'GET_ACCESS_PROFILES':
      return { ...state, accessProfiles: action.accessProfiles };
    default:
      return state;
  }
};
